export const PHOTOS = {
  "1. Pocock_Tassie-304": {
     "model": "EOS 5D Mark IV",
     "lens": "EF 50mm f/1.2L USM",
     "settings": "ISO 1000, f/5.0, 1/500s",
     "caption": "Almost 500,000ha of wild rainforests and bushland stretches across the north-west of Tasmania making it a photographer's paradise. "
  },
  "2. Pocock_Tassie-69": {
     "model": "EOS R",
     "lens": "RF 24-105mm F4 L IS USM",
     "settings": "ISO 2000, f/4.0, 1/2500s",
     "caption": "Day break across the Tarkine Wilderness Lodge run by local Maree Jenkins who's been fighting to protect her neighbour for over 30 years. "
  },
  "3. Pocock_Tassie-83": {
     "model": "EOS 5D Mark IV",
     "lens": "EF 50mm f/1.2L USM",
     "settings": "ISO 640, f/4.0, 1/100s",
     "caption": "\"It's under threat from mining and logging, so it would be really nice for it to be made a National Park or put it on the World Heritage listing,\" Maree says. "
  },
  "4. Pocock_Tassie-136": {
     "model": "EOS 5D Mark IV",
     "lens": "EF 24-105mm f/4L IS II USM",
     "settings": "ISO 800, f/4.0, 1/125s",
     "caption": "Mutual appreciation to preserve and protect between Maree and David. "
  },
  "5. Pocock_Tassie-98": {
     "model": "EOS-1D X Mark II",
     "lens": "EF 16-35mm f/2.8L II USM",
     "settings": "ISO 2000, f/2.8, 1/125s",
     "caption": "Scenes of green lit up by the breaks in the canopy. "
  },
  "6. Pocock_Tassie-91": {
     "model": "EOS 5D Mark IV",
     "lens": "EF 50mm f/1.2L USM",
     "settings": "ISO 640, f/3.5, 1/160s",
     "caption": "3/4 of Australia's rainforests have already been lost. This tract is the largest single tract in the country. "
  },
  "7. Pocock_Tassie-170": {
     "model": "EOS-1D X Mark II",
     "lens": "EF 100mm f/2.8L Macro IS USM",
     "settings": "ISO 12800, f/2.8, 1/160s",
     "caption": "Home to an abundance of flora and fungi… ideal macro photography subjects."
  },
  "8. Pocock_Tassie-94": {
     "model": "EOS 5D Mark IV",
     "lens": "EF 50mm f/1.2L USM",
     "settings": "ISO 640, f/3.5, 1/80s",
     "caption": "David hadn't spent much time shooting with the EF100mm macro but quickly became a fan of its uncompromising detail. "
  },
  "9. Pocock_Tassie-109": {
     "model": "EOS 5D Mark IV",
     "lens": "EF 24-105mm f/4L IS II USM",
     "settings": "ISO 800, f/4.0, 1/80s",
     "caption": "Surrounds which even dwarf one of Australia's strongest rugby players.  "
  },
  "10. Pocock_Tassie-131": {
     "model": "EOS R",
     "lens": "RF 24-105mm F4 L IS USM",
     "settings": "ISO 640, f/4.0, 1/60s",
     "caption": "Eternally damp and growing. "
  },
  "11. Pocock_Tassie-205": {
     "model": "EOS R",
     "lens": "RF 24-105mm F4 L IS USM",
     "settings": "ISO 2000, f/4.0, 1/160s",
     "caption": "Macro lenses have the capability to bring character and perspective to the smallest of subjects. "
  },
  "12. Pocock_Tassie-318": {
     "model": "EOS-1D X Mark II",
     "lens": "EF 16-35mm f/2.8L II USM",
     "settings": "ISO 1250, f/3.2, 1/40s",
     "caption": "Myrtle trees dominate the rainforests of the Tarkine and you can't help but feel their overwhelming presence."
  },
  "13. Pocock_Tassie-327": {
     "model": "EOS 5D Mark IV",
     "lens": "EF 50mm f/1.2L USM",
     "settings": "ISO 3200, f/3.5, 1/125s",
     "caption": "David shooting from a slice of the many kilometres of eco-walks Maree personally maintains year-round. "
  },
  "14. Pocock_Tassie-349": {
     "model": "EOS 5D Mark IV",
     "lens": "EF 50mm f/1.2L USM",
     "settings": "ISO 1000, f/2.8, 1/800s",
     "caption": "Tasmania's weather, like the Tarkine, is refreshingly wild, unpredictable and alive. Here, David begins stalking the local family of wedgies."
  },
  "15. Pocock_Tassie-379": {
     "model": "EOS-1D X Mark II",
     "lens": "EF 200-400mm f/4L IS USM EXT",
     "settings": "ISO 16000, f/5.6, 1/1600s",
     "caption": "\"I always felt being able to take a photo I could show someone how close I got and how special that bird was to me,” David says. "
  },
  "16. Pocock_Tassie-231": {
     "model": "EOS-1D X Mark II",
     "lens": "EF 200-400mm f/4L IS USM EXT",
     "settings": "ISO 3200, f/7.1, 1/800s",
     "caption": "A flame robin captured by David in a brief moment of stillness. "
  },
  "17. Pocock_Tassie-201": {
     "model": "EOS-1D X Mark II",
     "lens": "EF 200-400mm f/4L IS USM EXT",
     "settings": "ISO 800, f/5.6, 1/500s",
     "caption": "A yellow-tailed black cockatoo darts across the canopy. "
  },
  "18. Pocock_Tassie-294": {
     "model": "EOS R",
     "lens": "RF 24-105mm F4 L IS USM",
     "settings": "ISO 10000, f/4.0, 1/125s",
     "caption": "The spotted-tail quoll, a marsupial carnivore endangered on the mainland, captured feasting on a nearby roadkill. "
  },
  "19. Pocock_Tassie-19": {
     "model": "EOS-1D X Mark II",
     "lens": "EF 70-200mm f/2.8L IS II USM",
     "settings": "ISO 1600, f/4.0, 1/500s",
     "caption": "A large female wedge-tailed eagle blends cleverly into its surroundings."
  },
  "20. Pocock_Tassie-284": {
     "model": "EOS-1D X Mark II",
     "lens": "EF 200-400mm f/4L IS USM EXT",
     "settings": "ISO 12800, f/7.1, 1/1600s",
     "caption": "Weighing up to 5kgs and with a wing span of up to 2.2 metres, these birds of prey are something to behold as they soar over-head. "
  },
  "21. Pocock_Tassie-217": {
     "model": "EOS 5D Mark IV",
     "lens": "EF 24-105mm f/4L IS II USM",
     "settings": "ISO 320, f/4.0, 1/500s",
     "caption": "Never one to shy away from what he believes in. "
  },
  "22. Pocock_Tassie-267": {
     "model": "EOS 5D Mark IV",
     "lens": "EF 24-105mm f/4L IS II USM",
     "settings": "ISO 1000, f/5.0, 1/200s",
     "caption": "It's not all about rugby for this Australian Wallaby. "
  },
  "23. Pocock_Tassie-386": {
     "model": "EOS 5D Mark IV",
     "lens": "EF 24-105mm f/4L IS II USM",
     "settings": "ISO 800, f/5.0, 1/400s",
     "caption": "Local teacher, Adam Hardy runs Raptor Care North West, an organisation of civilians who rescue injured birds of prey.  "
  },
  "24. Pocock_Tassie-397": {
     "model": "EOS 5D Mark IV",
     "lens": "EF 24-105mm f/4L IS II USM",
     "settings": "ISO 1000, f/2.8, 1/640s",
     "caption": "This male wedgie is about four years old and sustained a damaged wing flying into electrical infrastructure.  "
  },
  "25. Pocock_Tassie-400": {
     "model": "EOS 5D Mark IV",
     "lens": "EF 24-105mm f/4L IS II USM",
     "settings": "ISO 1000, f/2.8, 1/640s",
     "caption": "An unlikely union unfolds in Tasmania. "
  },
  "26. Pocock_Tassie-406": {
     "model": "EOS 5D Mark IV",
     "lens": "EF 24-105mm f/4L IS II USM",
     "settings": "ISO 1000, f/2.8, 1/1000s",
     "caption": "David was visibly taken aback by their strength and ability to keep their head perfectly still.  "
  },
  "27. Pocock_Tassie-398": {
     "model": "EOS 5D Mark IV",
     "lens": "EF 24-105mm f/4L IS II USM",
     "settings": "ISO 1000, f/2.8, 1/640s",
     "caption": "In 1/160s the 5D Mark IV is able to capture the moment the wedgie blinks. "
  },
  "28. Pocock_Tassie-419": {
     "model": "EOS 5D Mark IV",
     "lens": "EF 24-105mm f/4L IS II USM",
     "settings": "ISO 1000, f/2.8, 1/640s",
     "caption": "Another bird of prey often rehabilitating in Adam's care is the Tasmanian grey goshawk. "
  },
  "29. Pocock_Tassie-431": {
     "model": "EOS-1D X Mark II",
     "lens": "EF 100mm f/2.8L Macro IS USM",
     "settings": "ISO 3200, f/6.3, 1/320s",
     "caption": "The goshawk's breeding is restricted to wet rainforests. Preserving the Tarkine is making sure that birds like this, and many others, keep their habitats. "
  },
  "30. Pocock_Tassie-411": {
     "model": "EOS 5D Mark IV",
     "lens": "EF 24-105mm f/4L IS II USM",
     "settings": "ISO 1000, f/2.8, 1/1000s",
     "caption": "For someone fascinated by birds his entire life, this was an story important for David to tell. "
  },
  "31. Pocock_Tassie-247": {
     "model": "EOS-1D X Mark II",
     "lens": "EF 200-400mm f/4L IS USM EXT",
     "settings": "ISO 3200, f/7.1, 1/1250s",
     "caption": "Wild, raw and over 60 million years of history. "
  },
  "32. Pocock_Tassie-303": {
     "model": "EOS 5D Mark IV",
     "lens": "EF 50mm f/1.2L USM",
     "settings": "ISO 1000, f/5.0, 1/500s",
     "caption": "For David, wearing the green and gold as a proud Australian is representing country – all its people, and importantly, all its land and creatures. "
  }
}